/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ role: NonNullable<unknown> }} User_Cannot_Change_RoleInputs */



/**
* | output |
* | --- |
* | "You cannot change {role}" |
*
* @param {User_Cannot_Change_RoleInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const user_cannot_change_role = /** @type {((inputs: User_Cannot_Change_RoleInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_Cannot_Change_RoleInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Vous ne pouvez pas modifier ${i?.role}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`No puede cambiar ${i?.role}`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`Você não pode alterar ${i?.role}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Non puoi modificare ${i?.role}`)
	return /** @type {LocalizedString} */ (`You cannot change ${i?.role}`)
});